import {
   MedicalCertificateApprovalResult,
   VisitMedicalCertificateApproveAndPrintCommand,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { printDocumentAsPdf } from '@dreryk/react-common';
import { usePushBack } from '@dreryk/react-components';
import { useDraftRemoveByTokenCqrsCommand } from '@dreryk/react-draft';

import { visitPaths } from '~libs.desktop.shared.paths';
import { useMedicalDocumentSigningStatusHandler } from '~libs.desktop.shared.medical-documentation';

import { getMedicalCertificateDraftToken } from '../medicalCertificate.draft';

import { MedicalCertificateFormBean } from './MedicalCertificateForm.types';
import { createMedicalCertificateFormPayload } from './MedicalCertificateForm.utils';

type VisitMedicalCertificateApproveAndPrintActionRenderProps = {
   approveAndPrint: (formData: MedicalCertificateFormBean) => Promise<MedicalCertificateApprovalResult>;
};

type VisitMedicalCertificateApproveAndPrintActionProps = {
   visitId: number;
   children: (renderProps: VisitMedicalCertificateApproveAndPrintActionRenderProps) => JSX.Element;
   onSuccess: VoidFunction;
};

export const VisitMedicalCertificateApproveAndPrintAction = (
   props: VisitMedicalCertificateApproveAndPrintActionProps
): JSX.Element => {
   const handleDocumentSigningStatus = useMedicalDocumentSigningStatusHandler();
   const pushBack = usePushBack();

   const { executeAsync: removeDraft } = useDraftRemoveByTokenCqrsCommand();

   const { executeAsync: approveAndPrint } = useCqrsCommand<
      MedicalCertificateApprovalResult,
      MedicalCertificateFormBean
   >(
      (parameters) => {
         const command = new VisitMedicalCertificateApproveAndPrintCommand();
         const { medicalCertificateParameters } = createMedicalCertificateFormPayload(parameters);
         command.visitId = props.visitId;
         command.medicalCertificateParameters = medicalCertificateParameters;
         return command;
      },
      {
         onSuccess: async ({ medicalCertificate, signingStatus }) => {
            await printDocumentAsPdf({
               base64: medicalCertificate.data,
            });
            handleDocumentSigningStatus(signingStatus);
            props.onSuccess();
            await removeDraft({ token: getMedicalCertificateDraftToken(props.visitId) });
            pushBack(
               visitPaths.getVisitInterviewPath({
                  params: { visitId: props.visitId },
               })
            );
         },
      }
   );

   return props.children({
      approveAndPrint: approveAndPrint,
   });
};
